import React, { type SVGProps } from 'react'

const LockIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="46"
    height="59"
    viewBox="0 0 46 59"
    fill="none"
    {...props}
  >
    <path
      d="M5.09703 17.6824V23.8495H4.65683C4.04495 23.8482 3.43882 23.9676 2.87324 24.2011C2.30767 24.4346 1.79378 24.7775 1.36108 25.2102C0.928389 25.6428 0.58541 26.1567 0.351838 26.7222C0.118267 27.2877 -0.00129735 27.8939 1.06164e-05 28.5057V54.2438C1.06164e-05 56.8242 2.07701 58.9006 4.65621 58.9006H40.5251C43.1055 58.9006 45.1819 56.8236 45.1819 54.2444V28.5057C45.1819 25.9253 43.1049 23.8489 40.5257 23.8489H40.3992V17.6824C40.3992 7.92856 32.4706 0 22.7168 0C13.0262 0 5.09703 7.92856 5.09703 17.6824ZM25.4225 42.4762C25.0449 42.7279 24.9823 42.9796 24.9823 43.4198V49.0835C25.0449 49.8387 24.6041 50.6565 23.9122 50.9714C22.2766 51.7892 20.6404 50.6565 20.6404 49.0835V43.4198C20.6404 43.0423 20.5772 42.7905 20.2002 42.5394C18.5008 41.2808 17.9341 39.1406 18.7525 37.2527C19.5709 35.428 21.5841 34.3585 23.5346 34.7355C25.6742 35.1763 27.1219 36.8751 27.1845 39.0147C27.1845 40.4624 26.6185 41.6578 25.4225 42.4762ZM12.8371 17.6824C12.8371 12.2078 17.3048 7.74008 22.7794 7.74008C28.254 7.74008 32.7224 12.2078 32.7224 17.6824V23.8495H12.8371V17.6824Z"
      fill="currentColor"
    />
  </svg>
)

export default LockIcon
